import React from 'react'
import moment from 'moment'
import { Button } from 'components/atoms'
import styled, { AnyStyledComponent } from 'styled-components'
import { COLORS } from '../../../../static/constants'
import { IOtaReservation } from 'static/interfaces'
interface IProps {
  otaReservation: IOtaReservation
  isEditing: boolean
  isSaving: boolean
  canEdit: boolean
  onStartEdit: () => void
  onSave: () => void | Promise<void>
  onCancel: () => void
}

const OtaReservationHeader: React.FC<IProps> = ({
  otaReservation,
  isEditing,
  isSaving,
  canEdit,
  onStartEdit,
  onSave,
  onCancel,
}) => {
  return (
    <OtaReservationHeaderWrapper className={`${isEditing ? 'editing' : ''}`}>
      <div className="heading">
        <h1>OTA予約情報詳細</h1>
        <span>id: {otaReservation.id}</span>
        <span className="status">{otaReservation.booking_status_id}</span>
      </div>
      <div className="actions">
        <span>作成日：{moment(otaReservation.created_at).format('YYYY/M/D')}</span>
        <span>更新日：{moment(otaReservation.updated_at).format('YYYY/M/D')}</span>
        {isEditing ? (
          <div className="edit-actions">
            <Button primary={true} small={true} handleClick={onSave} disabled={isSaving}>
              保存する
            </Button>
            <Button small={true} handleClick={onCancel} disabled={isSaving}>
              キャンセル
            </Button>
          </div>
        ) : canEdit ? (
          <Button small={true} handleClick={onStartEdit}>
            編集する
          </Button>
        ) : null}
      </div>
    </OtaReservationHeaderWrapper>
  )
}

export default OtaReservationHeader

const OtaReservationHeaderWrapper: AnyStyledComponent = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px 20px;
  flex-wrap: wrap;
  padding: 8px 12px;
  margin: -12px -12px 12px;
  &.editing {
    position: sticky;
    top: 0;
    background-color: ${COLORS.white};
    z-index: 10;
    border-radius: 4px;
  }

  .heading,
  .actions {
    display: flex;
    align-items: center;
    gap: 12px;
    .edit-actions {
      display: flex;
      gap: 8px;
    }
  }

  h1 {
    margin: 0;
    font-size: 20px;
  }

  span {
    color: ${COLORS.subText};
    font-size: 14px;
    white-space: nowrap;
  }

  .status {
    color: ${COLORS.primary};
  }

  @media (max-width: 960px) {
    align-items: flex-start;
    flex-direction: column;

    .heading,
    .actions {
      flex-wrap: wrap;
      gap: 12px;
    }
  }
`
